import { SiteDataFromApiProps } from "@/templates/types";

export type FallbackSiteData = SiteDataFromApiProps & { isFallback: true };

export const isFallbackSiteData = (siteData: unknown): siteData is FallbackSiteData =>
  typeof siteData === "object" &&
  siteData !== null &&
  (siteData as { isFallback?: unknown }).isFallback === true;

// Strict hostname: dot-separated labels of [a-z0-9-] and an alphabetic TLD
const DOMAIN_PATTERN = /^(?=.{1,253}$)(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z]{2,63}$/;

// The Host header is client-controlled and the domain ends up in HTML (web_name, web_mail),
// so anything that is not a plain hostname is discarded
export const getDomainFromHost = (host: string): string => {
  const domain = host
    .trim()
    .toLowerCase()
    .split(":")[0]
    .replace(/^www\./, "");
  return DOMAIN_PATTERN.test(domain) ? domain : "";
};

// Neutral site data resolved from the request host, used when /site/info is unavailable
// and there is no previous good value. Keeps the full shape so the layout never crashes.
export const buildFallbackSiteData = (host: string): FallbackSiteData => {
  const domain = getDomainFromHost(host);

  return {
    domain,
    webFulName: domain,
    hasChat: false,
    chatActive: false,
    hasPhone: false,
    theme: "classic",
    landing: null,
    phoneNumber: "",
    extraInfo: { key: "scstsl" },
    gtm: "",
    metadata: { termsAndConditions: [] } as unknown as SiteDataFromApiProps["metadata"],
    formAmount: 0,
    addons: [],
    isFallback: true,
  };
};
